import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  id: number;
  message: string;
  duration?: number;
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);
  let nextId = 1;

  function showToast(message: string, duration = 4000) {
    const id = nextId++;
    toasts.value.push({ id, message });
    const timeout = window.setTimeout(() => removeToast(id), duration);
    const toast = toasts.value.find(t => t.id === id);
    if (toast) toast.duration = timeout;
  }

  function removeToast(id: number) {
    const idx = toasts.value.findIndex(t => t.id === id);
    if (idx !== -1) {
      const toast = toasts.value[idx];
      if (toast.duration) window.clearTimeout(toast.duration);
      toasts.value.splice(idx, 1);
    }
  }

  return { toasts, showToast, removeToast };
});
